import {
  FormValidator,
  FormValidatorBase,
} from "@/app/dynamic-components/forms/form-validations/form-validator.base";
import {DynamicFormEntry} from "@/app/dynamic-components/forms/dynamic-form.model";

export default class MaxLengthFormValidator extends FormValidatorBase {
  constructor() {
    super("maxLength", "validations.maxLength");
  }

  isValid(formData: any, entry: DynamicFormEntry): boolean {
    if (formData === undefined || formData === null) return true;
    if(typeof formData !== 'string') return false;
    return formData.length <= this.params[0];
  }

  constructImpl(params: any[]): FormValidator {
    const validator = new MaxLengthFormValidator();
    params[0]  = params.length <= 0 ? 0 : Number.parseInt(params[0]);
    validator.params = params;
    return validator;
  }
}
